import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../resources/i18n/I18n'

const ModalDelete = ({ showModal, toggleModal, deleteLabel, title }) => {
  const handleDelete = () => {
    toggleModal()
    deleteLabel()
  }

  return (
    <Modal show={showModal} onHide={toggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('DeleteConfirmTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{title ? title : I18n.t('DeleteConfirmText')}</Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={toggleModal}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleDelete}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalDelete
